import { Component, OnInit, ViewChild } from '@angular/core';
import { GestoresService } from './services/gestores.service';
import { Gestor } from './interfaces/gestores.interface';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-gestores',
  templateUrl: './gestores.component.html',
  providers: [MessageService]
})
export class GestoresComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  
  dataSource: Gestor[] = [];
  loading: boolean = true;
  displayDialog: boolean = false;
  selectedGestor: Gestor | null = null;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'sAgencia', header: 'N° Agencia' },
    { field: 'sNombre', header: 'Nombre Agencia' },
    { field: 'clave', header: 'Clave' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private gestoresService: GestoresService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this.gestoresService.getGestores().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar datos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los datos'
        });
        this.loading = false;
      }
    });
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
  }

  openCreate(): void {
    this.selectedGestor = null;
    this.displayDialog = true;
  }

  openUpdate(gestor: Gestor): void {
    this.loading = true;
    // Cargar los datos completos del gestor
    this.gestoresService.getGestorById(gestor.sAgencia).subscribe({
      next: (response) => {
        if (response.success && response.data.length > 0) {
          this.selectedGestor = response.data[0];
          this.displayDialog = true;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los datos del gestor'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar datos del gestor:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los datos del gestor'
        });
        this.loading = false;
      }
    });
  }

  onDialogClosed(): void {
    this.selectedGestor = null;
    this.displayDialog = false;
  }

  onSave(event: { success: boolean; message: string }): void {
    if (event.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: event.message
      });
      this.displayDialog = false;
      this.loadData();
    }
  }

  openDelete(gestor: Gestor): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este gestor?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.gestoresService.deleteGestor(gestor.sAgencia).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Gestor eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el gestor'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el gestor'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }
} 